// A deposit amount is the amount of this transfer, never the member's balance.
import { BANK_NAMES, digits, normalizeBankCode, isUnified, visibleAccounts } from './receivingAccounts'
const amountInSatang = value => {
  if (!/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(String(value).trim())) return null
  const amount = Math.round(Number(value) * 100)
  return Number.isSafeInteger(amount) && amount > 0 ? amount : null
}
const normalizeAccount = (account, key, custom) => {
  const bankCode = custom ? normalizeBankCode(account.bankCode) : 'scb'
  const accountNo = digits(account.accountNo || account.accountno)
  return {
    accountId: account.accountId || account.id || (custom ? `custom-${bankCode}-${accountNo}` : key),
    bankCode, accountNo, bankName: BANK_NAMES[bankCode] || bankCode.toUpperCase(),
    accountName: account.accountName || `${account.firstname || ''} ${account.lastname || ''}`.trim()
  }
}
const customAccounts = deposit => {
  const smsNumbers = ['scb', 'scb2'].map(key => digits((deposit[key] || {}).accountno || (deposit[key] || {}).accountNo)).filter(Boolean)
  return Object.values(deposit.customBanks || {}).filter(account => account && account.active !== false && account.showOnWeb !== false &&
    (!Array.isArray(account.channels) || account.channels.includes('SCAN_SLIP')))
    .map(account => normalizeAccount(account, '', true))
    .filter(account => account.accountNo && BANK_NAMES[account.bankCode] &&
      !(account.bankCode === 'scb' && smsNumbers.includes(account.accountNo)))
}
const routeDeposit = (value, deposit = {}, choice = 0, now = Date.now()) => {
  const amountMinor = amountInSatang(value)
  if (amountMinor === null) return null
  if (isUnified(deposit)) {
    const visible = visibleAccounts(deposit, now)
    const scanAccounts = amountMinor < 200000 && deposit.slipReading !== false
      ? visible.filter(a => a.autoChannel === 'SCAN_SLIP') : []
    // Keep the existing amount policy: available Scan Slip accounts take priority
    // below 2,000; otherwise use SMS/LINE. Never mix the two pools randomly.
    const accounts = (scanAccounts.length ? scanAccounts : visible.filter(a => a.autoChannel !== 'SCAN_SLIP'))
      .map(a => ({ ...a, bankName: BANK_NAMES[a.bankCode] }))
    const account = accounts.length ? accounts[Math.min(accounts.length - 1, Math.floor(Math.max(0, choice) * accounts.length))] : null
    const scan = account && account.autoChannel === 'SCAN_SLIP'
    return { amountMinor, amount: amountMinor / 100, requiresSlip: !!scan, mode: scan ? 'custom_scan' : account && account.autoChannel === 'LINE' ? 'bank_line' : 'scb_sms', account, accounts }
  }
  // Preserve the existing policy until an administrator saves the unified list.
  const requiresSlip = amountMinor < 200000
  const custom = deposit.slipReading === false ? [] : customAccounts(deposit)
  const useCustom = requiresSlip && custom.length > 0
  const sms = deposit.scb && deposit.scb.show_frontend === false ? [] : ['scb', 'scb2']
    .filter(key => deposit[key] && deposit[key].active !== false)
    .map(key => normalizeAccount(deposit[key], key, false)).filter(account => account.accountNo)
  const accounts = useCustom ? custom : sms
  const account = accounts.length ? accounts[Math.min(accounts.length - 1, Math.floor(Math.max(0, choice) * accounts.length))] : null
  return { amountMinor, amount: amountMinor / 100, requiresSlip, mode: useCustom ? 'custom_scan' : 'scb_sms', account }
}
export { BANK_NAMES, digits, normalizeBankCode, amountInSatang, customAccounts, routeDeposit }
